import { render, staticRenderFns } from "./DeactivateLinkModal.vue?vue&type=template&id=74c2d9d7&"
import script from "./DeactivateLinkModal.vue?vue&type=script&lang=js&"
export * from "./DeactivateLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateLinkModal.vue?vue&type=style&index=0&id=74c2d9d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports